<template>
    <b-card border-variant="confirm">
        <b-card-text class="document-info">
            <div class="quality-document" @click="download">
                <b-row>
                    <b-col>
                        <app-sub-title
                            :text="`${file.code} - ${file.name}`"
                        ></app-sub-title>
                    </b-col>
                </b-row>
                <b-row align-v="center">
                    <b-col cols="auto">
                        <i
                            class="fa fa-3x document-icon"
                            :class="getIcon(file.lastVersion.doc_ext)"
                        ></i>
                    </b-col>
                    <b-col>
                        <b-row>
                            <b-col cols="12" md="6"
                                ><span class="file-label">Versión:</span></b-col
                            >
                            <b-col cols="12" md="6">{{
                                file.lastVersion.name
                            }}</b-col>
                            <b-col cols="12" md="6"
                                ><span class="file-label">Tipo:</span></b-col
                            >
                            <b-col cols="12" md="6">{{
                                file.lastVersion.doc_ext.toLowerCase()
                            }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6"
                                ><span class="file-label"
                                    >Fecha de actualización:</span
                                ></b-col
                            >
                            <b-col cols="12" md="6">{{
                                file.lastVersion.created_at | datetime
                            }}</b-col>

                            <b-col cols="12" md="6"
                                ><span class="file-label"
                                    >Actualizado por:</span
                                ></b-col
                            >
                            <b-col cols="12" md="6">{{
                                file.lastVersion.user.name
                            }}</b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
            <div>
                <b-row align-h="end" v-if="userCan('delete-quality-document')">
                    <b-col cols="auto">
                        <app-btn-confirm
                            variant="danger"
                            @confirm="deleteDocument"
                            confirm-variant="danger"
                            ><i class="fa fa-trash"></i
                        ></app-btn-confirm>
                    </b-col>
                </b-row>
            </div>
        </b-card-text>
    </b-card>
</template>
<script>
export default {
    props: {
        file: {
            type: Object,
            required: true,
        },
    },
    data: () => ({}),
    computed: {},
    methods: {
        download() {
            window.open(`download/quality-document/${this.file.id}`, '_blank')
        },
        deleteDocument() {
            this.$emit('delete', this.file)
        },
        getIcon(ext) {
            const dictionary = {
                pdf: 'fa-file-pdf-o red',
                xls: 'fa-file-excel-o green',
                xlsx: 'fa-file-excel-o green',
                csv: 'fa-file-excel-o green',
                doc: 'fa-file-word-o blue',
                docx: 'fa-file-word-o blue',
                jpg: 'fa-file-image-o yellow',
                jpeg: 'fa-file-image-o yellow',
                png: 'fa-file-image-o yellow',
                gif: 'fa-file-image-o yellow',
                txt: 'fa-file-text-o yellow',
                ppt: 'fa-file-powerpoint-o orange',
                pptx: 'fa-file-powerpoint-o orange',
            }

            return dictionary[ext] || 'fa-file-text-o gray'
        },
    },
}
</script>
<style scoped>
.file-label {
    color: #ff761c;
    font-weight: bold;
}
.quality-document {
    cursor: pointer;
}
.document-info {
    font-size: 0.8rem;
}
.orange {
    color: #ff761c;
}

.red {
    color: red;
}
.green {
    color: green;
}
.yellow {
    color: darkgoldenrod;
}
.blue {
    color: blue;
}
.gray {
    color: gray;
}
</style>
